/**
 * @module app.shared
 */

import { autoinject, ShadowDOM } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Indexed } from 'app/shared/lib/types';
import { Router } from 'aurelia-router';
import { EnableReturnFocusEvent } from 'app/shared/lib/events';
import { IScrollTarget } from 'app/shared/attributes/ess-scroll-attribute';
import { TabChangedEvent } from 'app/shared/elements/ess-tabs-horizontal';
import { guid } from 'app/shared/lib/guid';
import { EventAggregator } from 'aurelia-event-aggregator';

export interface INavigateBackEventDetails {
}

export type NavigateBackEvent = CustomEvent<INavigateBackEventDetails>;

@autoinject
export class EssCard {

    @bindable.stringNull()
    public labelledbyId: string | null = null;

    @bindable.booleanAttr()
    public styledHeader: boolean = false;

    @bindable
    public cardFooter: string = '';

    @bindable
    public showBack: boolean = false;

    public $slots: any = {};

    // refs
    protected cardScroll!: IScrollTarget;
    protected id: guid = guid();

    constructor(
        private readonly element: Element,
        private readonly router: Router,
        private readonly events: EventAggregator
    ) { }

    public attached(): void {
        this.$slots = this.getSpecifiedTemplateSlots(this.element);
    }

    protected handleBackClick(event: Event) {
        this.events.publish(new EnableReturnFocusEvent());
        const canceled = !this.element.dispatchEvent(
            new CustomEvent<INavigateBackEventDetails>('navigate-back', {
                detail: Object.freeze({}),
                bubbles: true,
                cancelable: true
            }));
        if(!canceled) {
            console.log('Default Navigate Back');
            // default behavior, navigate back in router
            this.router.navigateBack();
        }
    }

    protected handleTabChanged(event: TabChangedEvent) {
        this.cardScroll.scrollIntoView();
    }

    /**
     * Return which Aurelia slots were specified for a custom element
     *
     * See [this blog post](https://ilikekillnerds.com/2017/07/checking-view-slot-defined-aurelia/) for information
     * @param element
     *
     */
    private getSpecifiedTemplateSlots(element: Element): Indexed<boolean> {
        const defaultKey = ShadowDOM.defaultSlotKey;
        const results: Indexed<boolean> = {};
        // copy slots off of aurelia controller
        const slots = (<any>element).au.controller.view.slots;
        for(const key in slots) {
            const slot = slots[key];
            const targetKey = key === defaultKey ? '$' : key;
            results[targetKey] = (slot && slot.children && slot.children.filter((n: Node) => n.nodeType != Node.COMMENT_NODE).length > 0) || false;
        }
        return results;
    }

}
